<storever-tabs [data]="tabsData" [hideTabTile]="hideTabTile">
  <storever-tab [title]="tab.titleTab" [content]="tab.contentTab" [role]="tab.role"  *ngFor="let tab of tabsData.dataTabs">
    <ng-content></ng-content>
  </storever-tab>
</storever-tabs>
